export default {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  SEARCH: 'search',
  ICF: 'ICF',
  PAYPALGUIDE: 'PAYPAL_HELP_GUIDE',
  COMPLAINTS: 'complaints',
};
